import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=1c9c009a&scoped=true&"
import script from "./userManagement.vue?vue&type=script&lang=js&"
export * from "./userManagement.vue?vue&type=script&lang=js&"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=1c9c009a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9c009a",
  null
  
)

export default component.exports